import { render, staticRenderFns } from "./TuevCertificate.vue?vue&type=template&id=33454754&"
import script from "./TuevCertificate.vue?vue&type=script&lang=js&"
export * from "./TuevCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports